var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickLinksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5105,
    r: 40,
    fill: "#EEF4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9141 54.241V59.1501C49.9141 60.7682 48.6024 62.0798 46.9844 62.0798H24.2266C22.6085 62.0798 21.2969 60.7682 21.2969 59.1501V28.7332C21.2969 27.1151 22.6085 25.8035 24.2266 25.8035H31.0625V51.3113C31.0625 52.9293 32.3741 54.241 33.9922 54.241H49.9141Z",
    fill: "#75CFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7031 27.698V52.2878C58.7031 53.9059 57.3915 55.2175 55.7734 55.2175H33.0156C31.3976 55.2175 30.0859 53.9059 30.0859 52.2878V21.8708C30.0859 20.2528 31.3976 18.9412 33.0156 18.9412H50.2031L50.3008 19.0417L50.2031 19.1365V26.1062C50.2031 26.9853 50.9158 27.698 51.7949 27.698H58.5078L58.6084 27.6003L58.7031 27.698Z",
    fill: "#00ACEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6084 27.6003L58.5078 27.698H51.7949C50.9158 27.698 50.2031 26.9853 50.2031 26.1062V19.1365L50.3008 19.0417L58.6084 27.6003Z",
    fill: "#75CFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3106 39.7595H34.9883C34.4489 39.7595 34.0117 39.3223 34.0117 38.783C34.0117 38.2436 34.4489 37.8064 34.9883 37.8064H53.3106C53.8499 37.8064 54.2871 38.2436 54.2871 38.783C54.2871 39.3223 53.8499 39.7595 53.3106 39.7595ZM45.957 34.2966H34.9883C34.4489 34.2966 34.0117 33.8594 34.0117 33.3201C34.0117 32.7807 34.4489 32.3435 34.9883 32.3435H45.957C46.4964 32.3435 46.9336 32.7807 46.9336 33.3201C46.9336 33.8594 46.4964 34.2966 45.957 34.2966ZM53.3106 45.6189H34.9883C34.4489 45.6189 34.0117 45.1817 34.0117 44.6423C34.0117 44.103 34.4489 43.6658 34.9883 43.6658H53.3106C53.8499 43.6658 54.2871 44.103 54.2871 44.6423C54.2871 45.1817 53.8499 45.6189 53.3106 45.6189Z",
    fill: "#00EFD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickLinksIcon);
export default __webpack_public_path__ + "static/media/quickLinksIcon.ea2a7ef6.svg";
export { ForwardRef as ReactComponent };